import { render } from "./SuccessMessage.vue?vue&type=template&id=a6d57f38&scoped=true"
import script from "./SuccessMessage.vue?vue&type=script&lang=js"
export * from "./SuccessMessage.vue?vue&type=script&lang=js"

import "./SuccessMessage.vue?vue&type=style&index=0&id=a6d57f38&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6d57f38"]])

export default __exports__